import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export interface INmbrsHourCode {
    code: number;
    description: string;
}

export interface INmbrsWageCode {
    code: number;
    description: string;
}

export class NmbrsService extends BaseService<any> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'nmbrs');
    }

    /**
     * Haalt hourCodes op van NMBRS (voor looncomponenten)
     */
    public getHourCodes = (companyId?: number): ng.IPromise<INmbrsHourCode[]> => {
        let url = this.itemName + '/hourCodes';
        if (companyId) {
            url += '?companyId=' + companyId;
        }
        return this.Restangular.one(url).get().then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response || [];
        });
    }

    /**
     * Haalt wageCodes op van NMBRS (voor onkosten)
     */
    public getWageCodes = (companyId?: number): ng.IPromise<INmbrsWageCode[]> => {
        let url = this.itemName + '/wageCodes';
        if (companyId) {
            url += '?companyId=' + companyId;
        }
        return this.Restangular.one(url).get().then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response || [];
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/nmbrs.service.ts